/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getCopyrightMessage } from '../../../helpers/itpmetricsUtils';
import { languages, setLanguage } from '../../../helpers/utils';
import Section from '../../common/Section';

function FooterStandard() {
  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, []);

  const onKeyEnter = useCallback(
    (event) => {
      if (event.key === 'Enter') {
        scrollToTop();
      }
    },
    [scrollToTop],
  );

  const onSwitchLanguage = (language) => {
    setLanguage(language);
    window.location.reload();
  };

  return (
    <>
      <Section bg="dark" className="pt-8 pb-4 light">
        <div
          className="position-absolute btn-back-to-top cursor-pointer bg-dark"
          onClick={scrollToTop}
          onKeyDown={onKeyEnter}
          role="button"
          tabIndex={0}
        >
          <FontAwesomeIcon
            icon="chevron-up"
            transform="rotate-45"
            className="text-600"
          />
        </div>
      </Section>

      <section className=" bg-dark py-0 text-center fs--1 light">
        <hr className="my-0 border-600 opacity-25" />
        <div className="container py-3">
          <Row className="justify-content-between">
            <Col className="py-1">
              <p className="mb-0">
                Background image from
                {' '}
                <a href="https://www.flickr.com/photos/fruitsofkarma/16423287588">flickr.com</a>
              </p>
            </Col>
          </Row>
          <Row className="justify-content-between">
            <Col className="py-1">
              <p className="mb-0 text-600">
                {languages.map(({ caption, language }) => (
                  <a
                    className="text-white opacity-85 px-1"
                    href={null}
                    onClick={() => onSwitchLanguage(language)}
                    style={{ cursor: 'pointer' }}
                    key={`language-${language}`}
                  >
                    {caption}
                  </a>
                ))}
              </p>
            </Col>
            <Col className="py-1">
              <p className="mb-0 text-600">
                {getCopyrightMessage()}
                <span className="d-none d-sm-inline-block">{' | '}</span>
                <a
                  className="text-white opacity-85"
                  href="https://wpsites.ucalgary.ca/itp-lab/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Individual and Team Performance Lab
                </a>
              </p>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
}

export default FooterStandard;
